import { css } from "@emotion/css"

import Image from "@p-ban/common/src/components/html/Image"

import scrollTopImage from "./scrolltop.png"

const scrollTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  })
}

const ScrollTopButton = () => {
  return (
    <button type="button" className={styles.scrollTopButton} onClick={scrollTop}>
      <Image src={scrollTopImage} alt="スクロールトップ" width={25} height={25} />
    </button>
  )
}

export default ScrollTopButton

const styles = {
  scrollTopButton: css`
    position: fixed;
    right: 0;
    bottom: 50px;
    z-index: 50;
    width: 46px;
    height: 47px;
    padding: 10px;
    vertical-align: bottom;
    background-color: #ffffff;
    border: 1px solid #c2d0d7;
    border-right: none;
    border-radius: 5px 0px 0px 5px;
    &:hover {
      opacity: 0.7;
    }
  `,
}
